import { call, fork, put, takeEvery } from "typed-redux-saga";
import { getAppServerClient } from "@advosys/component-app-server-client-js";
import { actions, PreviewDialogActionTypes } from "./preview-dialog-store";
function* getPreview(action) {
    const apiResult = yield* call(getAppServerClient().documentGenerator.documentGeneratorV2.getPreparedInvoicePreviewAsync, action.payload.preparedInvoiceId);
    if (apiResult.ok) {
        yield* put(actions.getPreviewSuccess(apiResult.data.pdfDataBase64));
    }
    else {
        yield* put(actions.getPreviewFail(apiResult.error));
    }
}
function* watchGetPreviewRequest() {
    yield* takeEvery(PreviewDialogActionTypes.GetPreviewRequest, getPreview);
}
export const previewDialogSagaInit = () => [fork(watchGetPreviewRequest)];
